




































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import GoodsSelect from '@/components/goods-select/index.vue'
import ProductRelatedApi from '@/api/goods/related/index'

@Component({
  components: {
    GoodsSelect,
  },
})
export default class EditRelatedProduct extends Vue {
  exporting: boolean = false
  formItem = {
    id: null,
    name: '',
    products: [],
  }
  ruleValidate = {
    name: [{ required: true, message: '请输入分组名称', trigger: 'blur' }],
  }
  columns = [
    {
      title: '货号',
      key: 'productCode',
      width: 120,
    },
    {
      title: '商品名称',
      key: 'productName',
    },
    {
      title: '操作',
      key: 'action',
      slot: 'action',
      width: 120,
    },
  ]
  get selectedItems() {
    return this.formItem.products.map((t) => t.id)
  }
  mounted() {
    if (this.$route.params['id']) {
      this.formItem.id = this.$route.params['id']
      this.loadData()
    }
  }
  loadData() {
    ProductRelatedApi.getRelatedProduct(this.formItem.id).then((res) => {
      this.formItem = res.data
    })
  }
  save() {
    ;(this.$refs['formValidate'] as any).validate((valid) => {
      if (valid) {
        if (this.formItem.id) {
          ProductRelatedApi.updateRelatedProduct(this.formItem.id, this.formItem).then((res) => {
            this.$Message.success('保存成功')
            this.$router.push({ name: 'productRelated', replace: true })
          })
        } else {
          ProductRelatedApi.create(this.formItem).then((res) => {
            this.$Message.success('保存成功')
            this.$router.push({ name: 'productRelated', replace: true })
          })
        }
      }
    })
  }
  onChange(e) {
    if (e.length <= 0) {
      return
    }
    this.formItem.products = this.formItem.products.concat(
      e.map((t) => {
        return {
          productId: t.id,
          pictureUrl: t.pictureUrl,
          productCode: t.code,
          productName: t.name,
        }
      })
    )
  }
  deleteItem(index) {
    this.formItem.products.splice(index, 1)
  }
   /**
   * 导出excel表格
   */
  exportExcel() {
    this.exporting = true
    // let refForm: any = this.$refs.lineForm
    // const form = refForm.getForm()
    // let dateTimeRange = form['dateTimeRange']
    // console.log(form)
    let { id } = this.$route.params
    ProductRelatedApi.exportItemRelateProduct(id.toString())
      .then((res) => {
        console.log(res)
        this.exporting = false
        this.download(res.data)
      })
      .catch((err) => {
        this.exporting = false
      })
  }
  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '相关商品.xlsx')

    document.body.appendChild(link)
    link.click()
  }
}
